import React from 'react';
import { View, Pressable } from 'react-native';
import { Text } from '@/components/ui/text';

export interface FacetOption {
  id: string;
  slug: string;
  name: string;
}

interface FacetChipGridProps {
  options: FacetOption[];
  isSelected: (option: FacetOption) => boolean;
  onToggle: (option: FacetOption) => void;
  testIdPrefix: string;
}

/**
 * Presentational on/off chip grid for a single-valence facet (allergens, dietary).
 * Fully controlled: owns no selection state.
 */
export function FacetChipGrid({ options, isSelected, onToggle, testIdPrefix }: FacetChipGridProps) {
  return (
    <View className="flex-row flex-wrap gap-2">
      {options.map((option) => {
        const selected = isSelected(option);
        return (
          <Pressable
            key={option.id}
            testID={`${testIdPrefix}-${option.slug}`}
            onPress={() => onToggle(option)}
            accessibilityRole="button"
            accessibilityState={{ selected }}
            hitSlop={8}
            className={`rounded-full border px-3 py-1.5 ${selected ? 'border-primary bg-primary/10' : 'border-border'}`}
          >
            <Text className={`text-sm ${selected ? 'text-primary font-semibold' : 'text-foreground'}`}>
              {option.name}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}
